module.exports = __webpack_public_path__ + "img/ClickForSound_27.73f43f3a.png";